const EXTERNAL_LINKS = {
	tickets: "https://www.entrio.hr/event/weblica-2025-20699",
	sessions: "https://sessionize.com/weblica-2025/",
}

const TRACK_BREAK = (duration) => {
	return {
		duration: duration || 15,
		break: true,
		doNotEvaluate: true,
		title: {
			hr: "Pauza",
			en: "Break",
		},
	}
}

// const LUNCH_BREAK = (duration) => {
// 	return {
// 		duration: duration || 60,
// 		break: true,
// 		lunch: true,
// 		title: {
// 			hr: "Ručak",
// 			en: "Lunch",
// 		},
// 		// description: {
// 		// 	hr: "",
// 		// 	en: ""
// 		// },
// 	}
// }

module.exports = {
	currentYear: 2025,
	dateLimits: {
		ticketSales: {
			weblica: {
				from: null,
				to: "2025-05-09 23:59:59", // this needs to match last ticket sale date
			},
			worklica: {
				from: null,
				to: "2025-05-09 23:59:59", // this needs to match last ticket sale date
			},
		},
		lectureRegistration: {
			from: null,
			to: "2025-03-01 23:59:59",
		},
		workshopRegistration: {
			from: null,
			to: "2025-03-01 23:59:59",
		},
		teamRegistration: {
			from: null,
			to: "2025-04-30 23:59:59",
		},
		sponsorRegistration: {
			from: null,
			to: "2025-04-30 23:59:59",
		},
		exhibitorRegistration: {
			from: null,
			to: null, // "2025-04-30 23:59:59",
		},
		pressRegistration: {
			from: null,
			to: "2025-04-30 23:59:59",
		},
		volunteerRegistration: {
			from: null,
			to: "2025-05-05 23:59:59",
		},
		lastYearSurveyButton: {
			from: null,
			to: "2024-12-31 23:59:59",
		}
	},
	assets: {
		sponsorBrochure: {
			ident: {
				hr: "",
				en: "",
			},
			enabled: false,
		},
		exhibitorBrochure: {
			ident: {
				hr: "",
				en: "",
			},
			enabled: false,
		},
	},
	footerLinks: {
		code: {
			visible: true,
			extra: false,
			url: "/code",
			text: "more.code"
		},
		terms: {
			visible: true,
			extra: false,
			url: "/terms",
			text: "more.terms"
		},
		privacy: {
			visible: true,
			extra: false,
			url: "/privacy",
			text: "more.privacy"
		},
		recording: {
			visible: true,
			extra: false,
			url: "/recording",
			text: "more.recording"
		},
		safety: {
			visible: false,
			extra: true,
			url: "/safety",
			text: "more.safety"
		},
		press: {
			visible: true,
			extra: true,
			url: "/press",
			text: "more.press"
		},
		sponsor: {
			visible: true,
			extra: false,
			url: "/sponsors",
			text: "more.sponsor",
			dateLimit: "sponsorRegistration"
		},
		exhibitor: {
			visible: false,
			extra: false,
			url: "/exhibitors",
			text: "more.exhibitor",
			dateLimit: "exhibitorRegistration"
		},
		volunteer: {
			visible: true,
			extra: false,
			url: "/volunteer",
			text: "more.volunteer",
			dateLimit: "volunteerRegistration"
		}
	},
	events: {
		weblica: {
			tracks: ["track1"],
			externalLinks: EXTERNAL_LINKS,
			startDateTime: "2025-05-09 08:00:00",
			endDateTime: "2025-05-09 23:59:59",
			topicsTags: {
				hr: [
					"<b>JavaScript</b>",
					"NodeJS",
					"Bun",
					"React",
					"Vue",
					"Ember",
					"Angular",
					"Svelte",
					"NextJS",
					"Gatsby",
					"NuxtJS",
					"...",
					"<b>PHP</b>",
					"Laravel",
					"Symphony",
					"CakePHP",
					"CodeIgniter",
					"Zend Framework",
					"...",
					"<b>.NET</b>",
					"Azure Cloud Development",
					"Xamarin",
					"Blazor",
					"ML.NET",
					"<b>Python</b>",
					"Flask",
					"Django",
					"CherryPy",
					"Bottle",
					"...",
					"Web",
					"APIs",
					"Services",
					"PWAs",
					"...",
					"<b>Security</b>",
					"OWASP",
					"PenTesting",
					"...",
					"UI",
					"UX",
					"...",
					"Git",
					"Docker",
					"DevOps",
					"Cloud",
					"...",
					"AI",
					"ChatBots",
					"LowCode/NoCode",
					"Blockchain",
					"...",
				],
				en: [
					"<b>JavaScript</b>",
					"NodeJS",
					"Bun",
					"React",
					"Vue",
					"Ember",
					"Angular",
					"Svelte",
					"NextJS",
					"Gatsby",
					"NuxtJS",
					"...",
					"<b>PHP</b>",
					"Laravel",
					"Symphony",
					"CakePHP",
					"CodeIgniter",
					"Zend Framework",
					"...",
					"<b>.NET</b>",
					"Azure Cloud Development",
					"Xamarin",
					"Blazor",
					"ML.NET",
					"<b>Python</b>",
					"Flask",
					"Django",
					"CherryPy",
					"Bottle",
					"...",
					"Web",
					"APIs",
					"Services",
					"PWAs",
					"...",
					"<b>Security</b>",
					"OWASP",
					"PenTesting",
					"...",
					"UI",
					"UX",
					"...",
					"Git",
					"Docker",
					"DevOps",
					"Cloud",
					"...",
					"AI",
					"ChatBots",
					"LowCode/NoCode",
					"Blockchain",
					"...",
				],
			},
			menuItems: {
				about: {
					url: "/weblica#about",
					visible: false,
				},
				news: {
					url: "/weblica#news",
					visible: false,
				},
				speakers: {
					url: "/weblica#speakers",
					visible: true,
				},
				schedule: {
					url: "/weblica#schedule",
					visible: true,
				},
				venue: {
					url: "/weblica#venue",
					visible: "active,before", // true || false || "active,before,after" (status dependant)
				},
				faq: {
					url: "/weblica#faq",
					visible: "active,before",
				},
				sponsors: {
					url: "/weblica#sponsors",
					visible: true,
				},
				tickets: {
					url: "/weblica#tickets",
					visible: false,
				},
				testimonials: {
					url: "/weblica#testimonials",
					visible: false,
				},
			},
			buttons: {
				lecture: {
					title: "Call for Speakers",
					url: EXTERNAL_LINKS.sessions,
					hollow: true,
					external: true,
					visible: false,
					visibleOnHero: true,
					wide: true,
					// full: true,
					dateLimit: "lectureRegistration",
				},
				tickets: {
					title: "Get Tickets",
					url: "/weblica#tickets",
					hollow: false,
					external: false,
					visible: true,
					visibleOnHero: true,
					hollowOnHero: true,
					extraClassesOnHero: "showOnSmall",
					dateLimit: "ticketSales.weblica",
					floatingSpecial: {
						// used only on floating menu - if defined
						url: EXTERNAL_LINKS.tickets,
						external: true,
					},
				},
			},
			forcedButtons: {
				sponsor: {
					title: "Become a Sponsor",
					url: "/sponsors",
					hollow: true,
					external: false,
					visible: true,
					linkInFooter: true,
					dateLimit: "sponsorRegistration",
				},
				exhibitor: {
					title: "Become an Exhibitor",
					url: "/exhibitors",
					hollow: true,
					external: false,
					visible: false,
					linkInFooter: false,
					dateLimit: "exhibitorRegistration",
				},
				volunteer: {
					title: "Become a Volunteer",
					url: "/volunteer",
					hollow: true,
					external: false,
					visible: false,
					linkInFooter: true,
					dateLimit: "volunteerRegistration",
				},
			},
			sections: {
				hero: {
					visible: true,
					// introImage: {
					// 	file: "weblica-2024-125-1.jpg",
					// 	// file: "weblica-8105.jpg",
					// 	// file: "weblica-7988.jpg",
					// 	alt: "Weblica 2024",
					// },
					introVideo: [
						{
							media: "(max-width: 640px)",
							url: "/media/WEBLICA_banner_animation_640x360.mp4",
							poster: "/media/WEBLICA_banner_1280x720.png",
							type: "video/mp4"
						},
						{
							media: "(max-width: 1280px)",
							url: "/media/WEBLICA_banner_animation_1280x720.mp4",
							poster: "/media/WEBLICA_banner_1280x720.png",
							type: "video/mp4"
						},
						{
							media: "(min-width: 1281px)",
							url: "/media/WEBLICA_banner_animation_1920x1080.mp4",
							poster: "/media/WEBLICA_banner_1920x1080.png",
							type: "video/mp4"
						},
					],
					blocks: [],
				},
				about: {
					visible: true,
					blocks: [
						{
							width: "half", // full || half
							image: {
								file: "weblica-7573.jpg",
								alt: "Weblica 2019",
							},
						},
						{
							width: "half",
							text: "txt_aaa",
						},
						{
							width: "half",
							text: "txt_bbb",
						},
						{
							width: "half",
							image: {
								// file: "weblica-7810.jpg",
								file: "weblica-2024-24.jpg",
								alt: "Weblica 2024",
							},
						},
						{
							width: "half",
							// image: {
							// 	file: "weblica-8036.jpg",
							// 	alt: "Weblica 2019",
							// },
							gallery: {
								images: [
									{
										// title: "weblica-2024-181.jpg",
										img: "weblica-2024-181.jpg",
										alt: "Weblica 2024",
									},
									{
										// title: "weblica-2024-102.jpg",
										img: "weblica-2024-102.jpg",
										alt: "Weblica 2024",
									},
									{
										// title: "weblica-2024-125.jpg",
										img: "weblica-2024-125.jpg",
										alt: "Weblica 2024",
									},
									{
										// title: "weblica-2024-303.jpg",
										img: "weblica-2024-303.jpg",
										alt: "Weblica 2024",
									},
								]
							}
						},
						{
							width: "half",
							text: "txt_ccc",
						},
					],
				},
				news: {
					visible: false,
				},
				speakers: {
					visible: true,
				},
				schedule: {
					visible: true,
				},
				venue: {
					visible: true,
				},
				tickets: {
					visible: true,
				},
				faq: {
					visible: true,
				},
				testimonials: {
					visible: true,
				},
				historyGallery: {
					visible: true,
				},
				sponsors: {
					visible: true,
				},
				newsletter: {
					visible: true,
				},
			},
			venue: {
				venue: "dks"
			},
			_DEV_venue: [
				{
					ident: "dks",
					name: {
						hr: "Dom Kulture Štrigova",
						en: "Dom Kulture Štrigova"
					},
					nameAlt: {
						hr: "Dom Kulture Štrigova",
						en: "Dom Kulture Štrigova"
					},
					street: "Štrigova 103",
					postalCode: "40312",
					city: "Štrigova",
					country: "Croatia",
					countryShort: "HR",
					mapImage: "strigova-dom-kulture-map-2.jpg",
					mapUrl:
						"https://www.google.hr/maps/place/%C5%A0trigova+103,+40312,+%C5%A0trigova/@46.5001192,16.2885758,17z/data=!4m6!3m5!1s0x476f4ec49751d3a1:0x84a12a23fd1ca131!8m2!3d46.5001377!4d16.2901422!16s%2Fg%2F11rqx_d1s4?hl=hr&entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
					images: [
						{
							// title: "Zgrada Doma kulture",
							img: "dom_kulture_strigova-10.jpg"
						},
						{
							// title: "Glavna dvorana",
							img: "dom_kulture_strigova-8.jpg"
						},
						{
							// title: "Zona za partnere i pauze",
							img: "dom_kulture_strigova-2.jpg"
						},
						{
							// title: "Zona za partnere i pauze",
							img: "dom_kulture_strigova-a1.jpg"
						},
						{
							// title: "Chill out zona",
							img: "dom_kulture_strigova-3.jpg"
						},
					],
				},
				{
					ident: "dks2",
					name: {
						hr: "Dom Kulture Štrigova 2",
						en: "Dom Kulture Štrigova 2"
					},
					nameAlt: {
						hr: "Dom Kulture Štrigova",
						en: "Dom Kulture Štrigova"
					},
					street: "Štrigova 103",
					postalCode: "40312",
					city: "Štrigova",
					country: "Croatia",
					countryShort: "HR",
					mapImage: "strigova-dom-kulture-map-2.jpg",
					mapUrl:
						"https://www.google.hr/maps/place/%C5%A0trigova+103,+40312,+%C5%A0trigova/@46.5001192,16.2885758,17z/data=!4m6!3m5!1s0x476f4ec49751d3a1:0x84a12a23fd1ca131!8m2!3d46.5001377!4d16.2901422!16s%2Fg%2F11rqx_d1s4?hl=hr&entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
					// images: [
					// 	{
					// 		// title: "Zgrada Doma kulture",
					// 		img: "dom_kulture_strigova-10.jpg"
					// 	},
					// 	{
					// 		// title: "Glavna dvorana",
					// 		img: "dom_kulture_strigova-8.jpg"
					// 	},
					// 	{
					// 		// title: "Zona za partnere i pauze",
					// 		img: "dom_kulture_strigova-2.jpg"
					// 	},
					// 	{
					// 		// title: "Zona za partnere i pauze",
					// 		img: "dom_kulture_strigova-a1.jpg"
					// 	},
					// 	{
					// 		// title: "Chill out zona",
					// 		img: "dom_kulture_strigova-3.jpg"
					// 	},
					// ],
				},
			],
			_DEV_speakers: {
				"blau-frank": { // DEV
					keynote: true,
					image: "blau-frank.jpg",
					name: "Frank",
					surname: "Blau",
					contact: {
						email: "frank.blau@ebcont.com",
						phone: "+4366306601372",
					},
					position: "Principal Data Architect @ EBCONT",
					bio: "Frank Blau has been a Business Intelligence Data Architect for 15 years and has over 25 years of technical experience in relational and dimensional database technologies. He is currently a Principal Data Architect at EBCONT in Hard, Austria. He has been a developer, architect, analyst and educator in a variety of vertical markets and technologies. Frank has also been a consultant to Fortune 500 and mid-market companies in the use and implementation of data warehouse architectures, unstructured data, metadata management and analytic presentation.\r\n\r\nFrank is a 2018 and 2020 IBM Champion for Cloud and Blockchain, and was a 2014 IBM Champion for Information Management. He continues to provide thought leadership and research in such diverse areas as Streaming Data, Blockchain, Modern Data Architecture and Cloud Computing. Frank is also a public speaker and author on topics related to Business Intelligence, disruptive technologies, mobile computing and software methodologies and is also a member of the Digitale Initiativen in Dornbirn, Austria.",
					social: {
						linkedIn: "https://www.linkedin.com/in/frank-blau/",
					},
				},
				"begedin-nikola": { // DEV
					image: "begedin-nikola.jpg",
					name: "Nikola",
					surname: "Begedin",
					contact: {
						email: "begedinnikola@gmail.com",
						phone: "091 890 9997",
					},
					position: {
						hr: "Freelancer and full-stack developer @ V7Labs",
						en: "Freelancer and full-stack developer @ V7Labs",
					},
					bio: {
						// hr: "Počeo s .NET-om, dodao malo JS-a u mješavinu kako bi postao full stack, zatim prešao na Ruby on Rails s Emberom, ubrzo zamijenio Elixirom u backendu i zapravo svime na frontendu (trenutačno Vue).",
						hr: "Started with .NET, added some JS to the mix, to become full stack, then shifted to Ruby on Rails with Ember, soon replaced by Elixir on backend and basically anything on the frontend (currently Vue).",
						en: "Started with .NET, added some JS to the mix, to become full stack, then shifted to Ruby on Rails with Ember, soon replaced by Elixir on backend and basically anything on the frontend (currently Vue).",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/nikola-begedin-54541036/",
					},
				},
			},
			_DEV_sessions: [
				{ // DEV
					ident: "keynote-blau",
					duration: 30,
					language: "en",
					keynote: true,
					// doNotEvaluate: true,
					title: {
						hr: "DEV - A McLuhan-based approach to data architecture",
						en: "DEV - A McLuhan-based approach to data architecture",
					},
					description: {
						hr: "When Marshall McLuhan said in 1964 that “the medium is the message”, he was primarily speaking about the mediums of print, radio and television. As our industry grows in volume, variety and velocity, this statement remains an important touchpoint for examining our goals and how we create and investigate the content and structures that confront us today. Importantly, the industrial world today functions in what we observe to be a mullti-model ecosystem, with significant needs for harmonization and analytics. What we have learned is that in order to both understand and derive actionable insight from this dynamic world requires the adoption of multi-model techniques and platforms. In this presentation, this evolution and an approach to implementation is outlined and described as an extension of McLuhan’s statement, providing crucial grounding in today’s complex industrial data management landscape.",
						en: "When Marshall McLuhan said in 1964 that “the medium is the message”, he was primarily speaking about the mediums of print, radio and television. As our industry grows in volume, variety and velocity, this statement remains an important touchpoint for examining our goals and how we create and investigate the content and structures that confront us today. Importantly, the industrial world today functions in what we observe to be a mullti-model ecosystem, with significant needs for harmonization and analytics. What we have learned is that in order to both understand and derive actionable insight from this dynamic world requires the adoption of multi-model techniques and platforms. In this presentation, this evolution and an approach to implementation is outlined and described as an extension of McLuhan’s statement, providing crucial grounding in today’s complex industrial data management landscape.",
					},
					speakers: ["blau-frank"]
				},
				{ // DEV
					ident: "phoenix-live-view",
					duration: 30,
					language: "hr",
					level: "intermediate",
					code: "heavy",
					title: {
						hr: "DEV - Phoenix Live View - SPA u Elixiru s minimalno Javascripta",
						en: "DEV - Phoenix Live View - SPA u Elixiru s minimalno Javascripta",
						// en: "Phoenix Live View - SPA in Elixir with minimal Javascript",
					},
					description: {
						hr: 'Phoenix Live View je jedan od prvih "HTML kroz websockete" frameworka. Na poprilčno moćan način omogućava razvoj kompliciranih interakcija u web aplikaciji s minimalnom potrebom za JavaScriptom, a da pritom zaobilazi jedan čitav sloj u tipičnoj web aplikaciji - JSON/REST.',
						en: 'Phoenix Live View je jedan od prvih "HTML kroz websockete" frameworka. Na poprilčno moćan način omogućava razvoj kompliciranih interakcija u web aplikaciji s minimalnom potrebom za JavaScriptom, a da pritom zaobilazi jedan čitav sloj u tipičnoj web aplikaciji - JSON/REST.',
						// en: 'Phoenix Live View is one of the first "HTML through websockets" frameworks. In a rather powerful way, it enables the development of complicated interactions in a web application with a minimal need for JavaScript, while bypassing one entire layer in a typical web application - JSON/REST.',
					},
					speakers: ["begedin-nikola"]
				},
			],
			_DEV_schedule: [
				{ // DEV
					session: "keynote-blau"
				},
				TRACK_BREAK(),
				{ // DEV
					session: "phoenix-live-view"
				},
			],
			faq: {
				hr: [
					{
						title: "Što je Weblica?",
						short: "",
						full: "Weblica je konferencija posvećena web tehnologijama i IT sektoru koja okuplja različite stručnjake i entuzijaste iz cijele regije.",
					},
					{
						title: "Gdje i kada će se održati Weblica {{currentYear}}?",
						short: "",
						full: [
							"Weblica {{currentYear}} održat će se {{eventDate}} s početkom u {{eventTime}} sati.<br/>",
							"Adresa: {{venueNameAndAddress}}<br/><br/>",
							"Pronađi lokaciju <a href='{{mapUrl}}' target='_blank'>na ovoj karti</a>.",
						],
					},
					{
						title: "Kako se prijaviti za sudjelovanje kao predavač na Weblici i koji je rok za prijavu?",
						short: "",
						full: [
							`Prijave za predavače završavaju {{lectureRegistration.to}} u ponoć, a prijaviti se možete putem <a href='{{sessionsUrl}}' target='_blank'>Sessionize platforme</a>`,
						],
					},
					{
						title: "Koji su glavni sadržaji konferencije?",
						short: "",
						full: "Konferencija obuhvaća  razna predavanja, radionice i panel diskusije o najnovijim trendovima i temama u web tehnologijama.",
					},
					{
						title: "Koja je ciljna publika Weblice?",
						short: "",
						full: "Weblica okuplja stručnjake iz IT sektora, developere, programere, dizajnere, poduzetnike te sve koji su strastveni prema web tehnologijama.",
					},
					{
						title: "Kako mogu postati sponzor Weblice?",
						short: "",
						full: "Ako ste zainteresirani za sponzorstvo, pošaljite nam upit <a href='/{{linkLang}}/sponsors'>korištenjem ove forme.</a>",
					},
					{
						title: "Je li sudjelovanje na Weblici besplatno?",
						short: "",
						full: "Nažalost ne, ali cijene su iznimno pristupačne. Više informacija možete saznati na <a href='/{{linkLang}}/{{event}}/#tickets'>ovdje</a>.",
					},
					{
						title: "Trebam li imati tehničko predznanje za sudjelovanje na konferenciji?",
						short: "",
						full: "Weblica je namijenjena različitim razinama znanja, tako da i početnici i oni iskusniji mogu pronaći relevantne sadržaje.",
					},
					{
						title: "Kako mogu volontirati na konferenciji?",
						short: "",
						full: "Volonteri su i više nego dobro došli. Ako si zainteresiran(a) za sudjelovanje kao volonter, <a href='/{{linkLang}}/volunteer'>popuni ovu formu</a>.",
					},
					{
						title: "Hoće li negdje biti omogućeno parkirati automobil?",
						short: "",
						full: "Da, omogućen je besplatan parking.",
					},
					// {
					// 	title: "x",
					// 	short: "",
					// 	full: ""
					// },
				],
				en: [
					{
						title: "What is Weblica?",
						short: "",
						full: "Weblica is a conference dedicated to web technologies and the IT sector that brings together various experts and enthusiasts from the entire region.",
					},
					{
						title: "Do I need to have technical background to participate in the conference?",
						short: "",
						full: "Our conference is designed for attendees of all knowledge levels. We select sessions that are accessible to a broader audience, but also include advanced topics for more experienced participants. Each session is labeled with the required knowledge level, so you’ll know in advance if it’s beginner-friendly or more suited to experts.",
					},
					{
						title: "Where and when will Weblica {{currentYear}} be held?",
						short: "",
						full: [
							"<p>Weblica {{currentYear}} will be held on <b>{{eventDate}}</b>, starting at {{eventTime}}.<br/>",
							"It will be held at <a href='/{{event}}/{{linkLang}}#venue'><b>{{venueName}}</b></a><b>, {{venueAddress}}</b>.</p>",
							// "It will be held at <a href='{{mapUrl}}' target='_blank'><b>{{venueNameAndAddress}}</b></a>.</p>",
						],
					},
					{
						title: "How to apply for participation as a speaker on Weblica and what is the application deadline?",
						short: "",
						full: `Applications for speakers end on {{lectureRegistration.to}} at midnight, and you can register via <a href='{{sessionsUrl}}' target='_blank'>Sessionize platform</a>`,
					},
					// {
					// 	title: "What are the main contents of the conference?",
					// 	short: "",
					// 	full: "The conference includes various lectures, workshops and panel discussions on the latest trends and topics in web technologies.",
					// },
					{
						title: "What is the target audience of Weblica?",
						short: "",
						full: "Weblica brings together experts from the IT sector, developers, programmers, designers, entrepreneurs and everyone who is passionate about web technologies.",
					},
					{
						title: "How can I become a Weblica sponsor?",
						short: "",
						full: "If you are interested in sponsorship, please send us an inquiry <a href='{{urlPrefix}}/{{linkLang}}/sponsors'>using this form.</a>",
					},
					{
						title: "Is participation on Weblica free of charge?",
						short: "",
						full: "Unfortunately not, but the prices are very affordable. You can find out more information at <a href='{{urlPrefix}}/{{linkLang}}/{{event}}/#tickets'>here</a>.",
					},
					{
						title: "How can I volunteer at the conference?",
						short: "",
						full: "Volunteers are more than welcome. If you are interested in participating, please <a href='{{urlPrefix}}/{{linkLang}}/volunteer'>use this form</a>.",
					},
					{
						title: "Will it be possible to park a car somewhere?",
						short: "",
						full: "Yes, free parking is available.",
					},
					// {
					// 	title: "x",
					// 	short: "",
					// 	full: ""
					// },
				],
			},
			_BLANK_news: {
				hr: [],
				en: [],
			},
			news: {
				en: [
					{
						title: "Black Friday Offer",
						when: "2024-11-28",
						startDate: "2024-11-28 00:00:00",
						endDate: "2024-12-07 23:59:59",
						breaking: true,
						full: [
							"<p>Use promo code <b>BlackFridayWEBLICA</b> to get 20% off early bird tickets!<br/>",
							"Offer valid until December 7th, 2024.</p>",
							"<p><a href='#tickets'>Get Tickets</a></p>"
						]
					}
				]
			},
			_DEV_news: {
				hr: [],
				en: [
					{
						title: "DEV - Weblica is returning in the spring of 2025!",
						when: "2023-11-28",
						breaking: true,
						// shortImage: {
						// 	file: "weblica-8398-small.jpg",
						// 	alt: "weblica-8398",
						// },
						short: [
							"<p>After a prolonged and unplanned hiatus caused by the challenges of the COVID-19 pandemic, Weblica is thrilled to announce its comeback.</p>",
						],
						fullBlocks: [
							{
								width: "twoThirds",
								text: [
									"<p>The upcoming 6th conference on web technologies is scheduled for <b>{{eventDate}}</b>, at the heart of Međimurje - Čakovec.</p>",
									"<p>Over the years, Weblica has brought together more than 750 technology enthusiasts and featured over 70 prominent speakers, hosting developers, managers, designers, students, and all those who share a passion for the world of web technologies.</p>",
									"<p>Adapting to the global situation, organizers remained composed and directed their energy towards enhancing the conference experience, organizing, and ensuring an even more engaging event for all participants.</p>",
									'<p>Therefore, this year, Weblica changes its backdrop and moves to a new <a href="#venue">location</a> at <b>87 Zagrebačka Street</b> in <b>Čakovec</b>. This fresh and spacious venue, outside the city center, provides exciting opportunities for a more interactive atmosphere and new prospects for all attendees and speakers.</p>',
									"<p>Weblica is an essential event that leads in fostering the growth of the IT sector in the northwest region, providing the latest insights, tools, and collaboration opportunities. So, be part of Weblica 2024 and a day filled with knowledge exchange and networking opportunities with the fantastic IT community.</p>",
									'<p>We also invite potential speakers to share their knowledge, expertise, and experiences at the Weblica conference by submitting their presentations at the <a href="{{sessionsUrl}}" target="_blank">following link</a>.',
								],
							},
							{
								width: "third",
								image: {
									file: "weblica-8398.jpg", // "weblica-8273.jpg",
									alt: "weblica-8273",
								},
							},
						],
					},
					{
						title: "DEV - A two-floor conference experience!",
						when: "2024-03-14",
						// breaking: true,
						short: [
							"<p>Weblica 2024 brings big changes and new things that will make your conference experience better. </p>",
						],
						full: [
							"<p>This year, the conference will happen on two floors - one floor for inspiring talks, and the other one will be the center for extra stuff made just for the IT community.</p>",
							"<p>Keep following us because more details are coming soon.</p>",
						],
					},
					{
						title: "DEV - Comfortable accommodation during Weblica conference with a special discount",
						when: "2024-03-27",
						short: [
							"<p>Are you looking for the perfect place to rest close to the heart of the Weblica event?<br/>Do you want the comfort that comes with modern and affordable accommodation? We have great news for all our visitors!</p>",
						],
						full: [
							"<p>For everyone planning to stay in Čakovec during the Weblica conference, <a href='https://www.hostel-industrial.com' target='_blank'>Hostel Industrial</a> is offering an exclusive 10% discount on all accommodation bookings.</p>",
							"<p>To take advantage of this special discount, simply contact Hostel Industrial by email at <a href='mailto:info@hostel-industrial.com?subject=Reservation - Weblica2024' target='_blank'>info@hostel-industrial.com</a> with the promo code “Weblica2024” or show your Weblica ticket when booking directly at the hostel.</p>",
						],
					}
				],
			},
			tickets: [
				{
					ident: "student",
					icon: "student",
					title: {
						hr: "Student",
						en: "Student",
					},
					// description: {
					// 	hr: "",
					// 	en: [
					// 		"<p>This ticket gives you access to all conference sessions, three meals, after party, and the entry to <a href='https://vidikovac.eu/?lang=en' target='_blank'>Lookout Mađerkin Breg</a> Štrigova (with valid Weblica ticket).</p>",
					// 	]
					// },
					price: 24,
					listed: true,
					available: true,
					startDate: "2024-10-01",
					endDate: "2025-05-09 23:59:59",
					access: {
						conference: true,
						snacks: true,
						three_meals: true,
						after: true,
						extra_madjerka: true
					},
				},
				{
					ident: "early",
					icon: "clock",
					title: {
						hr: "Early",
						en: "Early",
					},
					// description: {
					// 	hr: "",
					// 	en: [
					// 		"<p>This ticket gives you access to all conference sessions, three meals, after party, and the entry to <a href='https://vidikovac.eu/?lang=en' target='_blank'>Lookout Mađerkin Breg</a> Štrigova (with valid Weblica ticket).</p>",
					// 	]
					// },
					price: 60,
					listed: true,
					available: true,
					startDate: "2024-10-01",
					endDate: "2024-12-31 23:59:59",
					access: {
						conference: true,
						snacks: true,
						three_meals: true,
						after: true,
						extra_madjerka: true
					},
				},
				{
					ident: "regular",
					icon: "standard",
					title: {
						hr: "Regular",
						en: "Regular",
					},
					// description: {
					// 	hr: "",
					// 	en: [
					// 		"<p>This ticket gives you access to all conference sessions, three meals, after party, and the entry to <a href='https://vidikovac.eu/?lang=en' target='_blank'>Lookout Mađerkin Breg</a> Štrigova (with valid Weblica ticket).</p>",
					// 	]
					// },
					price: 120,
					listed: true,
					available: true,
					startDate: "2025-01-01",
					endDate: "2025-05-09 23:59:59",
					access: {
						conference: true,
						snacks: true,
						three_meals: true,
						after: true,
						extra_madjerka: true
					},
				}
			],
			testimonials: [
				{
					speaker: true,
					name: "Frank",
					description: {
						hr: "",
						en: "Data Architect",
					},
					text: {
						hr: [],
						en: [
							"<p>The tangible \"startup energy\", crowd enthusiasm, and passion for engagement with all the participants was a real boost for me. While a lot of the content was in Croatian, everyone I talked to in groups and in person made an effort to communicate in English (and a bit of German!). The food, weather and setting were also wonderful!! I look forward to following your growth and returning again next year!</p>",
						],
					},
				},
				{
					name: "Ivan",
					description: {
						hr: "developer",
						en: "Developer",
					},
					text: {
						hr: [
							"<p>Na Weblici sam naučio puno novih i korisnih stvari koje koristim svakoga dana, a osim predavanja - ekipa i hrana su super. </p>",
						],
						en: [
							"<p>At Weblica, I learned many new and useful things that I use every day, and besides the lectures - the team and the food are great.</p>",
						],
					},
				},
				{
					speaker: true,
					name: "Marko",
					description: {
						hr: "developer",
						en: "Developer",
					},
					text: {
						hr: [
							"<p>Weblica je sinonim za vrhunske predavače,najnovije trendove u IT-u, pregršt zabave i druženje s kolegama. Zato obavezno stavite Weblicu u vaš kalendar i vidimo se u svibnju u Čakovcu.</p>",
						],
						en: [
							"<p>Weblica is synonymous with top-notch speakers, the latest trends in IT, loads of fun, and networking with colleagues. That's why you should definitely put Weblica in your calendar and see you in May in Čakovec.</p>",
						],
					},
				},
				{
					speaker: true,
					name: "Tomislav",
					description: {
						hr: "Dizajner",
						en: "Designer",
					},
					text: {
						hr: [
							"<p>Weblica je jedno predivno iskustvo jer su prisutni ljudi poput vas, ljudi koji rade isti posao i koji su uspjeli u karijeri koju svi dijelimo. Može se jako puno naučiti iiz predavanja, ali i direktne komunikacije s predavačima jer to nisu neki tamo eterični ljudi iz cijelog svijeta - to su ljudi iz naše okoline koji znaju svoj posao. Mislim da je Weblica super prilika za naučiti nešto novo i napredovati u svojoj karijeri.</p>",
							"<p>Ekipa koja organizira Weblicu, koja stoji iza nje, je zakon. Atmosfera je fantastična i vidi se da ljudi rade sa strašću. Preporučam konferenciju svakome, neće faliti ni dobre zabave, ni hrane, a ni pića.</p>",
						],
						en: [
							"<p>Weblica is one marvelous experience because it is attended by people like you, people who do the same job and who have succeeded in the career we all share. There's so much to learn not only from the lectures but also from direct communication with the speakers because they aren't just some ethereal people from around the world - they are people from our environment who know their job. I think Weblica is a great opportunity to learn something new and advance in your career.</p>",
							"<p>The team organizing Weblica, who stands behind it, is awesome. The atmosphere is fantastic and you can see that people work with passion. I recommend the conference to everyone, there will be no shortage of good fun, food, or drinks.</p>",
						],
					},
				},
				{
					name: "Kristina",
					description: {
						hr: "developer",
						en: "Developer",
					},
					text: {
						hr: [],
						en: [
							"<p>Weblica 2024 was a very interesting experience. The sessions I joined were really informative. I confirmed some things I already knew and learned a lot of new ideas. Honestly, the food was way better than I expected. Good variety, and I didn’t go hungry.</p>",
						],
					},
				},
				{
					name: "Davor",
					description: {
						hr: "Developer",
						en: "Developer",
					},
					text: {
						hr: [
							"<p>Na Weblicu dolazim od njenog drugog izdanja, i od tad sam stalni član i posjetitelj ovog eventa. Po mojem, ovo je najbolji event u ovoj regiji, što se tiče programske i dizajnerske industrije. Vidimo se na druženju uz pive i ostalo.</p>",
						],
						en: [
							"<p>I have been coming to Weblica since its second edition. In my opinion, this is the best event in this region regarding the programming and design industry. Hope to see you at the gathering with beers and the rest.</p>",
						],
					},
				},
				{
					name: "Viktor",
					description: {
						hr: "Developer",
						en: "Developer",
					},
					text: {
						hr: [
							"<p>Na Weblicu se vraćam svake godine. Sviđa mi se networking, druženje s ljudima, super je ekipa i super su predavanja. Bilo bi mi drago da ima više tema vezanih uz Java programiranje.</p>",
						],
						en: [
							"<p>I come to Weblica every year. I like networking and socializing with people, the team is great and so are the lectures. I would be glad if there were more topics related to Java programming.</p>",
						],
					},
				},
				{
					name: "Nikola",
					description: {
						hr: "Developer",
						en: "Developer",
					},
					text: {
						hr: [],
						en: [
							"<p>I've attended Weblica since 2019, and the 2024 one was the best so far. The venue was good, and having two parallel tracks made it easy to pick sessions that suited me. Some sessions could have gone a bit deeper into the subject, but overall, it was definitely worth the visit. And, of course, catching up with fellas from the industry made it all the more special and memorable.</p>",
						],
					},
				},
			],
			extraContent: [
				{
					ident: "blackFriday2024",
					location: "tickets-aboveBuyButton",
					from: "2024-11-28 00:00:00",
					to: "2024-12-07 23:59:59",
				}
			]
		},
		hacklica: {
			config: { // override config.js setup - disable this event for year 2025
				enabled: false,
				active: false,
				visible: false,
				visibleInHeader: false,
			},
			startDateTime: null, // "2025-05-03 08:00:00",
			endDateTime: null, // "2025-05-04 08:00:00",
			specialDates: {
				demos: null,
				winningCeremony: null,
			},
			prizeAmounts: [5000, 3000, 1500],
			menuItems: {
				about: {
					menu: "About",
					url: "/hacklica#about",
					visible: false,
				},
				news: {
					menu: "News",
					url: "/hacklica#news",
					visible: false,
				},
				topics: {
					menu: "Topics",
					url: "/hacklica#topics",
					visible: false,
				},
				venue: {
					menu: "Venue",
					url: "/hacklica#venue",
					visible: false,
				},
				faq: {
					menu: "FAQ",
					url: "/hacklica#faq",
					visible: false,
				},
				sponsors: {
					menu: "Sponsors",
					url: "/hacklica#sponsors",
					visible: false,
				},
				terms: {
					menu: "Terms",
					url: "/hacklica/terms",
					special: true,
					visible: false,
				},
				policy: {
					menu: "Policy",
					url: "/hacklica/policy",
					special: true,
					visible: false,
				},
			},
			buttons: {
				register: {
					title: "Register your team",
					url: "/hacklica/register",
					hollow: true,
					dateLimit: "teamRegistration",
					visible: false,
				},
			},
			forcedButtons: {
				sponsor: {
					title: "Become a Sponsor",
					url: "/sponsors",
					hollow: true,
					external: false,
					visible: false,
					dateLimit: "sponsorRegistration",
				},
			},
			sections: {
				hero: {
					visible: true,
					// introImage: {
					// 	file: "hacklica-2019-2.jpg",
					// 	alt: "Hacklica 2019",
					// },
					introVideo: [
						{
							media: "(max-width: 640px)",
							url: "/media/WEBLICA_banner_animation_640x360.mp4",
							poster: "/media/WEBLICA_banner_1280x720.png",
							type: "video/mp4"
						},
						{
							media: "(max-width: 1280px)",
							url: "/media/WEBLICA_banner_animation_1280x720.mp4",
							poster: "/media/WEBLICA_banner_1280x720.png",
							type: "video/mp4"
						},
						{
							media: "(min-width: 1281px)",
							url: "/media/WEBLICA_banner_animation_1920x1080.mp4",
							poster: "/media/WEBLICA_banner_1920x1080.png",
							type: "video/mp4"
						},
					],
					blocks: [],
				},
				about: {
					visible: true,
					blocks: [
						{
							width: "half", // full || half
							image: {
								file: "hacklica-2019-3.jpg",
								alt: "Hacklica 2019",
							},
						},
						{
							width: "half",
							text: "txt_aaa",
						},
					],
				},
				news: {
					visible: false,
				},
				topics: {
					visible: true,
				},
				venue: {
					visible: true,
				},
				faq: {
					visible: true,
				},
				sponsors: {
					visible: true,
				},
				newsletter: {
					visible: true,
				},
				testimonials: {
					visible: false,
				},
				historyGallery: {
					visible: true,
				},
			},
			__venue: {
				name: {
					hr: "Graditeljska škola",
					en: "School of Architecture",
				},
				nameAlt: {
					hr: "Dvorana Graditeljske škole",
					en: "Hall of the School of Architecture",
				},
				street: "Športska ulica 1",
				postalCode: "40000",
				city: "Čakovec",
				country: "Croatia",
				countryShort: "HR",
				leaflet: {
					location: [46.38921, 16.42269],
					zoom: 19,
				},
				mapUrl:
					"https://www.google.com/maps/place/Graditeljska+%C5%A1kola+%C4%8Cakovec/@46.3888122,16.4220393,15z/data=!4m5!3m4!1s0x0:0x129b433371a3c66f!8m2!3d46.3888122!4d16.4220399",
				mapImage: "gsc-dvorana-map.png",
				images: ["gsc-dvorana-1.jpeg", "gsc-dvorana-2.jpeg"],
			},
			__faq: {
				hr: [
					{
						title: "HR-HH-faq 1",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 2",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 3",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 4",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 5",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 6",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 7",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 8",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
				en: [
					{
						title: "EN-What is the smallest or the largest team size?",
						short:
							"Minimum is 2 members (as you probably expected) and the largest team can have up to 6 members. Everything in between is fine by us.",
						full: "Minimum is 2 members (as you probably expected) and the largest team can have up to 6 members. Everything in between is fine by us.",
					},
					{
						title: "Can we base our work on preexisting work of ours?",
						short: "Short answer would be-no! But ...",
						full: "If your team has some utilities or smaller libraries that can aid you, yes, you can use that. But beware! We will check the code (it is part of judging process) and we will disqualify full teams if we notice that code volume is not consistent with what is possible in 24 hour window. You will be able to speak up of course if such event occurs, but we are all seniors here and can not be fooled so easily!",
					},
					{
						title: "faq 3",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 4",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
			},
			__news: {
				hr: [
					{
						title: "HR-HH-here we go again",
						when: "2021-09-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "HH-here we go again #2",
						when: "2021-09-03 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "",
					},
					{
						title: "HH-full steam ahead",
						when: "2021-11-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "HH-tickets are ready-go go go",
						when: "2024-01-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
				en: [
					{
						title: "EN-HH-here we go again",
						when: "2021-09-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "HH-here we go again #2",
						when: "2021-09-03 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "",
					},
					{
						title: "HH-full steam ahead",
						when: "2021-11-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "HH-tickets are ready-go go go",
						when: "2024-01-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
			},
			__topics: {
				hr: [
					{
						title: "HR topic 1",
						short:
							"HR Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "HR topic 2",
						short:
							"HR Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "HR topic 3",
						short:
							"HR Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
				],
				en: [
					{
						title: "EN topic 1",
						short:
							"EN Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "EN topic 2",
						short:
							"EN Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "EN topic 3",
						short:
							"EN Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
				],
			},
		},
		worklica: {
			config: { // override config.js setup
				enabled: false // TODO: remove this temporary block when all data is available
			},
			tracks: ["track1"],
			externalLinks: EXTERNAL_LINKS,
			startDateTime: "2025-05-09 08:00:00",
			endDateTime: "2025-05-09 23:59:59",
			options: {
				showRegisterButton: true,
			},
			menuItems: {
				about: {
					menu: "About",
					url: "/worklica#about",
					visible: false,
				},
				news: {
					menu: "News",
					url: "/worklica#news",
					visible: false,
				},
				speakers: {
					menu: "Speakers",
					url: "/worklica#speakers",
					visible: true,
				},
				schedule: {
					menu: "Schedule",
					url: "/worklica#schedule",
					visible: true,
				},
				tickets: {
					menu: "Tickets",
					url: "/worklica#tickets",
					visible: false,
				},
				venue: {
					menu: "Venue",
					url: "/worklica#venue",
					visible: "active,before",
				},
				faq: {
					menu: "FAQ",
					url: "/worklica#faq",
					visible: "active,before",
				},
				sponsors: {
					menu: "Sponsors",
					url: "/worklica#sponsors",
					visible: true,
				},
			},
			buttons: {
				tickets: {
					title: "Get Tickets",
					url: "/worklica#tickets",
					hollow: false,
					external: false,
					visible: false,
					dateLimit: "ticketSalesWorklica",
				},
				register: {
					title: "Register a workshop",
					url: EXTERNAL_LINKS.sessions,
					hollow: true,
					external: true,
					visible: false,
					visibleOnHero: true,
					dateLimit: "workshopRegistration",
				},
			},
			forcedButtons: {
				sponsor: {
					title: "Become a Sponsor",
					url: "/sponsors",
					hollow: true,
					external: false,
					visible: true,
					linkInFooter: true,
					dateLimit: "sponsorRegistration",
				},
			},
			sections: {
				hero: {
					visible: true,
					// introImage: {
					// 	file: "worklica-2019-1.jpg",
					// 	alt: "Worklica 2019",
					// },
					introVideo: [
						{
							media: "(max-width: 640px)",
							url: "/media/WEBLICA_banner_animation_640x360.mp4",
							poster: "/media/WEBLICA_banner_1280x720.png",
							type: "video/mp4"
						},
						{
							media: "(max-width: 1280px)",
							url: "/media/WEBLICA_banner_animation_1280x720.mp4",
							poster: "/media/WEBLICA_banner_1280x720.png",
							type: "video/mp4"
						},
						{
							media: "(min-width: 1281px)",
							url: "/media/WEBLICA_banner_animation_1920x1080.mp4",
							poster: "/media/WEBLICA_banner_1920x1080.png",
							type: "video/mp4"
						},
					],
					blocks: [],
				},
				about: {
					visible: true,
					blocks: [
						{
							width: "half", // full || half
							image: {
								file: "worklica-2019-4.jpg",
								alt: "Worklica 2019",
							},
						},
						{
							width: "half",
							text: "txt_aaa",
						},
						{
							width: "half",
							text: "txt_bbb",
						},
						{
							width: "half", // full || half
							image: {
								file: "worklica-2019-2.jpg",
								alt: "Worklica 2019",
							},
						},
					],
				},
				news: {
					visible: false,
				},
				speakers: {
					visible: true,
				},
				schedule: {
					visible: true,
				},
				venue: {
					visible: true,
				},
				tickets: {
					visible: false,
				},
				faq: {
					visible: true,
				},
				sponsors: {
					visible: true,
				},
				newsletter: {
					visible: true,
				},
				testimonials: {
					visible: false,
				},
				historyGallery: {
					visible: true,
				},
			},
			venue: [
				{
					venue: "dks"
				},
				{
					venue: "vxy"
				}
			],
			__tickets: [
				{
					ident: "worklica",
					icon: "worklica",
					title: {
						hr: "Early Bird",
						en: "Early Bird",
					},
					// description: {
					// 	hr: "Dođite na radionice i učite radeći na primjerima!",
					// 	en: "Attend the workshops and learn hands-on!",
					// },
					// access: {
					// 	worklica: true,
					// 	goodies: true,
					// 	lunch: true,
					// },
					price: 100,
					listed: true,
					available: true,
					startDate: "2024-07-01",
					endDate: "2024-09-15 23:59:59",
				},
				{
					ident: "worklica",
					icon: "worklica",
					title: {
						hr: "Standard Bird",
						en: "Standard Bird",
					},
					// description: {
					// 	hr: "Dođite na radionice i učite radeći na primjerima!",
					// 	en: "Attend the workshops and learn hands-on!",
					// },
					// access: {
					// 	worklica: true,
					// 	goodies: true,
					// 	lunch: true,
					// },
					price: 125,
					listed: true,
					available: true,
					startDate: "2024-09-16",
					endDate: "2024-10-10 23:59:59",
				},
			],
			speakers: {
				// "culjak-ivan": {
				// 	image: "culjak-ivan.jpg",
				// 	name: "Ivan",
				// 	surname: "Čuljak",
				// 	contact: {
				// 		email: "ivan@culjak.xyz",
				// 		phone: "+385914404403"
				// 	},
				// 	position: {
				// 		hr: "Cloud Whisperer @ Cloudlet Ltd",
				// 		en: "Cloud Whisperer @ Cloudlet Ltd"
				// 	},
				// 	bio: {
				// 		hr: "A developer evolved into an architect. Loved salvaging wrecks, now enjoys correcting the course well before the wreck happens. Keeps postponing releasing his SaaS and podcast.",
				// 		en: "A developer evolved into an architect. Loved salvaging wrecks, now enjoys correcting the course well before the wreck happens. Keeps postponing releasing his SaaS and podcast."
				// 	},
				// 	social: {
				// 		linkedIn: "https://www.linkedin.com/in/ivandothr/"
				// 	},
				// },
			},
			sessions: [
			],
			schedule: [
			],
			faq: {
				hr: [],
				en: [
					{
						title: "Who is Worklica for?",
						short: "",
						full: "Worklica is designed for developers who want to explore technical challenges and solutions in greater detail. Unlike conference sessions, workshops offer more time to dig deeper into specific topics, sometimes requiring active participation. Each workshop will indicate whether hands-on involvement is expected.",
					},
					{
						title: "Do I need to have technical background to participate in the conference?",
						short: "",
						full: "The required knowledge level for each workshop depends on the topic. Some workshops will dive deep into technical subjects, while others may be more accessible to beginners. Each workshop will clearly state the knowledge level required, so you can choose the ones that best fit your experience.",
					},
					{
						title: "Where and when will Worklica {{currentYear}} be held?",
						short: "",
						full: [
							"<p>Worklica {{currentYear}} will be held on <b>{{eventDate}}</b>, starting at {{eventTime}}.<br/>",
							"It will be held at <a href='/{{event}}/{{linkLang}}#venue'><b>{{venueName}}</b></a><b>, {{venueAddress}}</b>.</p>",
							// "It will be held at <a href='{{mapUrl}}' target='_blank'><b>{{venueNameAndAddress}}</b></a>.</p>",
						],
					},
					{
						title: "How to apply for participation as a lecturer on Worklica and what is the application deadline?",
						short: "",
						full: `Applications for speakers end on {{workshopRegistration.to}} at midnight, and you can register via <a href='{{sessionsUrl}}' target='_blank'>Sessionize platform</a> (please notice Session type entry).`,
					},
					{
						title: "How can I become a Worklica sponsor?",
						short: "",
						full: "If you are interested in sponsorship, please send us an inquiry <a href='{{urlPrefix}}/{{linkLang}}/sponsors'>using this form.</a>",
					},
					{
						title: "Is participation on Worklica free of charge?",
						short: "",
						full: "Unfortunately not, but the prices are very affordable. You can find out more information at <a href='{{urlPrefix}}/{{linkLang}}/{{event}}/#tickets'>here</a>.",
					},
					{
						title: "Will it be possible to park a car somewhere?",
						short: "",
						full: "Yes, free parking is available.",
					},
					// {
					// 	title: "x",
					// 	short: "",
					// 	full: ""
					// },
				],
			},
			__news: {
				hr: [
					{
						title: "HR-HH-here we go again",
						when: "2021-09-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "HH-here we go again #2",
						when: "2021-09-03 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "",
					},
					{
						title: "HH-full steam ahead",
						when: "2021-11-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "HH-tickets are ready-go go go",
						when: "2024-01-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
				en: [
					{
						title: "EN-HH-here we go again",
						when: "2021-09-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "HH-here we go again #2",
						when: "2021-09-03 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "",
					},
					{
						title: "HH-full steam ahead",
						when: "2021-11-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "HH-tickets are ready-go go go",
						when: "2024-01-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
			},
		},
	},
	generic: { // show on all events - news is first combined and then sorted by date, faq is added to the end of event faq
		news: {
			hr: [],
			en: [],
		},
		faq: {
			hr: [],
			en: [],
		},
	},
	venues: [ // generic and reused venues
		{
			ident: "dks",
			name: {
				hr: "Dom Kulture Štrigova",
				en: "Cultural center Štrigova"
			},
			nameAlt: {
				hr: "Dom Kulture Štrigova",
				en: "Cultural center Štrigova"
			},
			// url: "https://opcinastrigova.hr/dom-kulture-strigova/",
			// description: {
			// 	hr: [
			// 		"<p>Centar je kulturnih zbivanja na području Općine Štrigova pa i šire.  Isti je obnovljen i rekonstruiran 2021. godine te je tako ukupna površina proširena na 1 172 kvadratna metra koji koriste udruge civilnog društva te služi i za organizaciju kulturnih i društvenih događanja. Multifunkcionalni ambijent prostora, opremljenost i koncepcija, omogućavaju  održavanje više aktivnosti odjednom pri čemu se svakoj može osigurati određena izoliranost.</p>",
			// 		"<p>Dom se sastoji od prezentacijskog i enogastronomskog prostora, male dvorane za predavanje i prezentacije, prostora za druženje te komforne kuhinje u prizemlju, dok se na prvom katu nalazi suvremeno opremljena dvorana s 224 sjedeća mjesta za razne glazbeno-scenske aktivnosti, kazališne i filmske projekcije, skupove te kongrese.  Za osobe smanjene pokretljivosti osiguran je lift kako bi im se olakšalo kretanje po domu.</p>"
			// 	],
			// 	en: [
			// 		"<p>It is the center of cultural events in the area of ​​Štrigova Municipality and beyond. It was renovated and reconstructed in 2021, and thus the total area was expanded to 1,172 square meters, which is used by civil society associations and is also used for the organization of cultural and social events. The multifunctional ambience of the space, the equipment and the concept, make it possible to hold several activities at the same time, while each can be provided with a certain isolation.</p>",
			// 		"<p>The home consists of a presentation and enogastronomy area, a small hall for lectures and presentations, a space for socializing and a comfortable kitchen on the ground floor, while on the first floor there is a modernly equipped hall with 224 seats for various musical and stage activities, theater and film projections, gatherings and congresses. An elevator is provided for people with reduced mobility to make it easier for them to move around the house.</p>"
			// 	]
			// },
			street: "Štrigova 103",
			postalCode: "40312",
			city: "Štrigova",
			country: "Croatia",
			countryShort: "HR",
			mapImage: "strigova-dom-kulture-map-2.jpg",
			mapUrl:
				"https://www.google.hr/maps/place/%C5%A0trigova+103,+40312,+%C5%A0trigova/@46.5001192,16.2885758,17z/data=!4m6!3m5!1s0x476f4ec49751d3a1:0x84a12a23fd1ca131!8m2!3d46.5001377!4d16.2901422!16s%2Fg%2F11rqx_d1s4?hl=hr&entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D",
			images: [
				{
					// title: "Zgrada Doma kulture",
					img: "dom_kulture_strigova-10.jpg"
				},
				{
					// title: "Glavna dvorana",
					img: "dom_kulture_strigova-8.jpg"
				},
				{
					// title: "Zona za partnere i pauze",
					img: "dom_kulture_strigova-2.jpg"
				},
				{
					// title: "Zona za partnere i pauze",
					img: "dom_kulture_strigova-a1.jpg"
				},
				{
					// title: "Chill out zona",
					img: "dom_kulture_strigova-3.jpg"
				},
			],
		},
		{
			ident: "vxy",
			name: {
				hr: "Vinarija XY",
				en: "Vinarija XY"
			},
			nameAlt: {
				hr: "Vinarija XY",
				en: "Vinarija XY"
			},
			street: "Štrigova XY",
			postalCode: "40312",
			city: "Štrigova",
			country: "Croatia",
			countryShort: "HR",
		}
	],
	sponsors: {
		l5: [
			{
				name: "TRIA",
				logo: "tria_primarni_logotip_white and red_bez slogana.png",
				url: "https://tria.hr",
				linkedIn: "https://www.linkedin.com/company/tria-hr",
				tags: [
					"Web Development", "JavaScript", "Frontend", "Backend", "System Architecture", "Databases", "Custom Solutions", "DevOps"
				],
				description: {
					hr: [],
					en: [
						"<p>Tria is a software development company focused on building tailored solutions for complex business challenges.</p>",
						"<p>With experience across industries like eCommerce, fintech, health tech, pharma, logistics, and automotive, Tria adapts its skills to meet diverse sector needs.</p>",
						"<p>Their technology stack is centered on JavaScript, utilizing Vue.js, Docker, PostgreSQL, and other advanced technologies to deliver high-performance, custom software solutions.</p>",
						"<p>Tria’s services cover everything from system architecture, software development, and DevOps, to UI/UX design, product development and consulting.</p>"
					]
				}
			},
			{
				name: "Factory X",
				url: "https://factory-x.hr",
				logo: "factory-x-logo.svg",
				tags: [
					"Web Development", "Machine Learning", "Databases", "Graph databases", "DevOps", "Dynamics 365", "Business solutions"
				],
				description: {
					hr: [
					],
					en: [
						"<p>At Factory X, we specialize in creating custom software solutions for industries such as education, finance, medicine, recruiting, and beyond. Our focus is on building long-term partnerships and delivering tailored solutions that drive success.</p>",
						"<p>From consultation and requirements gathering to design, development, and support, we take care of it all. Our innovative, secure, and scalable solutions are crafted to overcome your challenges and help your business thrive in an ever-evolving market.</p>"
					]
				}
			},
		],
		l4: [
			{
				name: "Općina Štrigova",
				logo: "opcina-strigova-grb.png",
				url: "https://opcinastrigova.hr/",
				linkedIn: "",
				description: {
					hr: [],
					en: [
						"<p>Nestled in the beautiful hills of Međimurje, Štrigova is a place where rich history meets a warm, welcoming community. Known for its stunning landscapes, abundant vineyards, and cultural heritage, Štrigova is a picturesque destination where tradition meets innovation.</p>",
						"<p>The Cultural Center Štrigova will serve as the main venue for Weblica 2025, providing a scenic and relaxed setting for learning, networking, and innovation.</p>"
					]
				},
				extra: {
					padding: "35px"
				}
			},
		],
		l3: [
			{
				name: "ENTRIO",
				logo: "Entrio logo_negative_color.png",
				url: "https://entrio.hr",
				linkedIn: "https://www.linkedin.com/company/entrio/",
				tags: [
					"Event Ticketing", "Event Management", "Conferences", "Festivals", "User-friendly platform"
				],
				description: {
					hr: [],
					en: [
						"<p>Entrio is an event ticketing platform, simplifying the ticketing experience for events of all sizes - from conferences and festivals to exclusive workshops.</p>",
						"<p>With intuitive tools for ticket management, audience engagement, and data insights, Entrio helps organizers create memorable events without the hassle.</p>"
					]
				}
			},
		],
		l2: [
			{
				name: "The Geek Gathering",
				logo: "tgg-green.svg",
				url: "https://thegeekgathering.org/",
				linkedIn: "https://www.linkedin.com/company/geekgathering/",
				tags: [
					"Conference", "Tech", "Discussions", "Workshops", "Osijek", "Real talks", "Back-to-back insights", "Gathering"
				],
				description: {
					hr: [],
					en: [
						"<p>The Geek Gathering is an event brought to you by fellow tech minds. It is designed by and for tech and design experts in Southeastern Europe, the world, the galaxy, the universe, and the metaverse.</p>",
						"<p>TGG is not just a conference but a two-day gathering of tech optimists to exchange ideas, share skills, and build connections.</p>",
						"<p>Our goal is to bring together tech talent, entrepreneurs, and thought leaders to establish a hub of tech innovation and disruption in Osijek and the surrounding region.</p>",
						"<p>In 2024, a partnership between The Geek Gathering and Weblica was formed, recognizing that similar events with a shared mission of advancing tech knowledge should support one another.</p>"
					]
				}
			},
		],
		l1: [
			{
				name: "Thera",
				// logo: "thera-logo-v4b-full-white-horizontal.svg",
				logo: "thera-logo-v4b-white-with-accent-horizontal.svg",
				// logoLight: "thera.png"
				url: "https://thera.hr",
				linkedIn: "https://www.linkedin.com/company/thera-webdev",
				tags: [
					"Web Development", "Frontend", "Backend", "API", "Databases", "Project Management & Consulting"
				],
				description: {
					hr: [],
					en: [
						"<p>Our mission is to create optimal web based solutions for complex problems, while being fully aligned with your needs and requirements. We can do that as a direct solution provider or as part of a larger team where we will contribute to the development by bringing experience and knowledge to the table, enhancing the whole process.</p>",
						"<p>By openly communicating about all the details - from our first contact, through discovery, development and maintenance stages - we ensure the quality of the product we deliver.</p>",
					]
				}
			},
		]
	},
	exhibitors: [
	],
	partners: {
	},
	__mediaPartners: [
		{
			name: "toptal",
			url: "",
			logo: "toptal.svg",
		},
		{
			name: "veniture",
			url: "",
			logo: "veniture.svg",
		},
	],
	survey: { // generic survey questions (used only if event specific are not defined)
		visitors: [
			{ // OK
				required: true,
				question: { // this is used to generate "key" needed for internal logic
					hr: "Koliko ste općenito zadovoljni događajem?",
					en: "How satisfied were you with the event in general?",
				},
				// description: { // additional info about the question, eq. clarification
				// 	hr: "Općenito organizacija i dojam koji je događaj ostavio na Vas.",
				// 	en: "General organization and the impression the event left on you."
				// },
				stars: true, // type
				// boolean: true, // type
				// comment: true, // type
				comment_opt: true, // optional comment
				// options: { // type
				// 	type: "checkbox", // checkbox or radio
				// 	items: [
				// 		{
				// 			value: "collegues",
				// 			hr: "Kolega u firmi",
				// 			en: "Colleagues in the company",
				// 		},
				// 	]
				// },
			},
			{ // OK
				required: true,
				event: ["weblica"], // for which event - generic if not given
				question: {
					hr: "Koliko ste zadovoljni ukupnom kvalitetom predavanja?",
					en: "How satisfied are you with the general quality of the sessions?",
				},
				stars: true,
				comment_opt: true,
			},
			{ // OK
				question: {
					hr: "Koje je bilo Vaše najdraže iskustvo ili trenutak događaja?",
					en: "What was your favorite experience or moment of the event?",
				},
				comment: true,
			},
			{ // OK
				question: {
					hr: "Što bismo mogli poboljšati?",
					en: "What could we improve on?",
				},
				comment: true,
			},
			{ // OK
				question: {
					hr: "Da li je događaj ispunio vaša očekivanja?",
					en: "Did the event meet your expectations?",
				},
				boolean: true,
				comment_opt: true,
			},
			{ // OK
				question: {
					hr: "Kolika je vjerojatnost da ćete u budućnosti posjećivati ​​naše događaje?",
					en: "How likely would you be to attend our events in the future?",
				},
				stars: true,
				comment_opt: true,
			},
			{ // OK
				question: {
					hr: "Biste li naše događaje preporučili prijatelju ili kolegi?",
					en: "Would you recommend our events to a friend or colleague?",
				},
				boolean: true,
				comment_opt: true,
			},
			{ // OK
				question: {
					hr: "Jeste li imali priliku i mjesto za postavljanje pitanja i sudjelovanje?",
					en: "Did you have an opportunity and place to ask questions and participate?",
				},
				boolean: true,
				comment_opt: true,
			},
			{ // OK
				question: {
					hr: "Koliko ste bili zadovoljni pruženim mogućnostima umrežavanja?",
					en: "How satisfied were you with the networking opportunities provided?",
				},
				stars: true,
				comment_opt: true,
			},
			{ // OK
				question: {
					hr: "Kako ste saznali za ovaj događaj?",
					en: "How did you hear about this event?",
				},
				options: {
					type: "checkbox",
					items: [
						{
							value: "colleague-friend",
							text: {
								hr: "Kolega/Prijatelj/Poznanik",
								en: "Colleague/Friend/Acquaintance",
							}
						},
						{
							value: "social-network",
							text: {
								hr: "Društvene mreže",
								en: "Social network",
							}
						},
						{
							value: "portal",
							text: {
								hr: "IT portal",
								en: "IT portal",
							}
						},
						{
							value: "newsletter",
							text: {
								hr: "Newsletter",
								en: "Newsletter",
							}
						},
						{
							value: "poster",
							text: {
								hr: "Plakat",
								en: "Poster",
							}
						},
						{
							value: "other",
							text: {
								hr: "Neki drugi način ...",
								en: "Some other way ...",
							}
						},
					],
				},
				comment_opt: true,
				comment_placeholder: {
					hr: "Ako ste saznali na neki drugi način, molimo da ovdje napišete kako?",
					en: "If you heard about this event in another way, please tell us how?",
				},
			},
			{ // OK
				question: {
					hr: "Jeste li već bili na ovom događaju?",
					en: "Have you attended this event before?",
				},
				boolean: true,
				comment_opt: true,
			},
			{ // OK
				question: {
					hr: "Koliko Vam je osoblje bilo od pomoći?",
					en: "How helpful was the staff at the event?",
				},
				stars: true,
				comment_opt: true,
			},
			{ // OK
				question: {
					hr: "Koliko je platforma za događaj bila jednostavna za navigaciju?",
					en: "How easy-to-navigate was the platform for the event?",
				},
				stars: true,
				comment_opt: true,
			},
			{ // OK - ADDED
				question: {
					hr: "Da li su oznake u i oko prostora bile dostatne za snalaženje?",
					en: "Were the markings in and around the event area sufficient for navigation?",
				},
				stars: true,
				comment_opt: true,
			},
			{ // OK
				question: {
					hr: "Koje biste teme voljeli vidjeti više na budućim događanjima?",
					en: "What topics would you want to see more of at future events?",
				},
				comment: true,
			},
			{ // OK
				question: {
					hr: "Molimo podijelite sve dodatne komentare, misli, prijedloge za buduće događaje.",
					en: "Please share any additional comments, thoughts, suggestions for future events.",
				},
				comment: true,
			},
		],
		speakers: [
			{ // OK
				required: true,
				question: {
					hr: "Koliko ste općenito zadovoljni događajem?",
					en: "How satisfied were you with the event in general?",
				},
				stars: true,
				comment_opt: true,
			},
			{ // OK
				question: {
					hr: "Koje je bilo Vaše najdraže iskustvo ili trenutak događaja?",
					en: "What was your favorite experience or moment of the event?",
				},
				comment: true,
			},
			{ // OK
				question: {
					hr: "Gdje ste saznali da se možete prijaviti kao predavač na našoj konferenciji?",
					en: "Where did you find out that you can register as a lecturer at our conference?",
				},
				comment: true
			},
			{ // OK
				question: {
					hr: "Jesu li tehnička podrška i oprema zadovoljili vaše potrebe tijekom predavanja?",
					en: "Did the technical support and equipment meet your needs during the presentation?",
				},
				boolean: true,
				comment_opt: true
			},
			{ // OK
				question: {
					hr: "Kako ocjenjujete organizaciju i komunikaciju s organizacijskim timom prije i tijekom konferencije?",
					en: "How do you rate the organization and communication with the organizing team before and during the conference?",
				},
				stars: true,
				comment_opt: true
			},
			{ // OK
				question: {
					hr: "Kako biste ocijenili interes i angažman publike tijekom vašeg predavanja?",
					en: "How would you assess the interest and engagement of the audience during your presentation?",
				},
				stars: true,
				comment_opt: true
			},
			{ // OK
				question: {
					hr: "Jesu li vam pružene dovoljne prilike za networking i interakciju s ostalim predavačima i sudionicima?",
					en: "Were you provided with sufficient opportunities for networking and interaction with other speakers and participants?",
				},
				boolean: true,
				comment_opt: true
			},
			{ // OK
				question: {
					hr: "Postoji li nešto što bi moglo biti poboljšano u vezi s vašim iskustvom na konferenciji?",
					en: "Is there anything that could be improved in relation to your experience at the conference?",
				},
				comment: true
			},
			{ // OK
				required: true,
				question: {
					hr: "Biste li se željeli vratiti kao predavač na budućim izdanjima naše konferencije?",
					en: "Would you like to return as a speaker at future editions of our conference?",
				},
				boolean: true,
				comment_opt: true
			},
			{ // OK
				question: {
					hr: "Imate li preporuke za teme ili sadržaje koji bi mogli obogatiti buduća izdanja naše konferencije?",
					en: "Do you have any recommendations for topics or content that could enrich future editions of our conference?",
				},
				comment: true
			},
		],
	},
}